var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundBankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.416,
    height: 64.416,
    rx: 32.208,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8158 45.7083H19.6003C19.1359 45.7083 18.7598 45.3322 18.7598 44.8678V42.9064C18.7598 42.442 19.1359 42.0659 19.6003 42.0659H44.8158C45.2801 42.0659 45.6563 42.442 45.6563 42.9064V44.8678C45.6563 45.3322 45.2801 45.7083 44.8158 45.7083Z",
    fill: "#DA867D",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8958 18.7682L19.288 23.9235C18.9691 24.0513 18.7598 24.3602 18.7598 24.7039V26.8805C18.7598 27.3448 19.1359 27.721 19.6003 27.721H44.8158C45.2801 27.721 45.6563 27.3448 45.6563 26.8805V24.7039C45.6563 24.3602 45.447 24.0513 45.128 23.9235L32.5203 18.7682C32.3198 18.6879 32.0962 18.6879 31.8958 18.7682Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.208 22.3418V24.135",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0353 42.0656H21.4492V27.7209H25.0353V42.0656Z",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0016 42.0656H30.4155V27.7209H34.0016V42.0656Z",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9664 42.0656H39.3804V27.7209H42.9664V42.0656Z",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundBankIcon);
export default __webpack_public_path__ + "static/media/RoundBankIcon.52aee98d69c82ca8a7a2720f6bc7992b.svg";
export { ForwardRef as ReactComponent };